import { FrontPagePanelType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IPagePanel, PagePanel } from "../common/pagePanel";
import { TaskPagePanel } from "../task";

export class FrontPagePanel extends PagePanel implements IPagePanel {
    getTitle(): string {
        switch (this.panelType) {
        case FrontPagePanelType.Banner:
            return Translations.Banner;
        case FrontPagePanelType.Message:
            return Translations.CurrentTopics;
        case FrontPagePanelType.Event:
            return Translations.Events;
        case FrontPagePanelType.Image:
            return Translations.Images;
        case FrontPagePanelType.UserModifiedRecords:
            return Translations.MyLastModifications;
        case FrontPagePanelType.OtherModifiedRecords:
            return Translations.OthersLastModifications;
        case FrontPagePanelType.ToDo:
            return Translations.ToDo;
        case FrontPagePanelType.DocumentBrowser:
            return Translations.FrontPageDocuments;
        case FrontPagePanelType.TaskPanel:
            return TaskPagePanel.getPanelTitle(this.id);
        default:
            return this.title || "";
        }
    }

    getUniqueId(): string {
        return this.id;
    }
}